import type { BonusProgramEligibility } from "@/lib/storefront/account/bonus-program-service"

export function shouldHideBonusProgramEligibility(eligibility?: BonusProgramEligibility) {
  if (!eligibility) {
    return true
  }

  return (
    eligibility.reasons?.includes("BONUS_PROGRAM_NOT_STARTED") === true ||
    eligibility.programActive === false ||
    eligibility.active === false
  )
}
